<!-- 系统映射关系 -->
<template>
  <div class="mappingData">
    <vxe-table
      border
      resizable
      show-overflow
      :data="dataHistories"
      size="mini"
      ref="dataHistoriesTable"
      auto-resize
    >
      <vxe-table-column type="index" width="60" :title="$t('goods.table.index')"></vxe-table-column>
      <vxe-table-column field="gmtCreate" :title="$t('goods.table.time')"></vxe-table-column>
      <vxe-table-column field="createByName" title="操作人"></vxe-table-column>
      <vxe-table-column field="operatorIp" title="操作人IP"></vxe-table-column>
      <vxe-table-column
        field="updateContent"
        :title="$t('goods.table.updateContent')"
      ></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  export default {
    name: 'mappingData',
    props: ['dataHistories'],
  };
</script>

<style scoped></style>
